(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-icons"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Gump: the solo leader and the whole convoy cover different distances,
    // so split the cycle by distance to keep the same speed on both passes.
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (root) => {
      const stage = root.querySelector('.floating-icons__stage');
      const solo = root.querySelector('.floating-icons__solo');
      const convoy = root.querySelector('.floating-icons__convoy');
      if (!stage || !solo || !convoy || reduceMotion.matches || !solo.animate) return;

      let animations = [];
      let measured = '';

      const run = () => {
        const stageWidth = stage.clientWidth;
        const soloWidth = solo.offsetWidth;
        const convoyWidth = convoy.offsetWidth;
        if (!stageWidth || !soloWidth || !convoyWidth) return;

        // Skip when nothing that affects the path changed (e.g. height-only resize)
        const key = `${stageWidth}|${soloWidth}|${convoyWidth}`;
        if (key === measured) return;
        measured = key;

        const style = getComputedStyle(root);
        const passDuration = (parseFloat(style.getPropertyValue('--floating-icon-duration')) || 20) * 1000;
        const iterationsValue = style.getPropertyValue('--floating-icon-iterations').trim();
        const iterations = iterationsValue === 'infinite' ? Infinity : parseFloat(iterationsValue) || Infinity;

        // Duration setting = time for the leader to cross alone; the convoy keeps that speed
        const soloDistance = stageWidth + soloWidth;
        const convoyDistance = stageWidth + convoyWidth;
        const split = soloDistance / (soloDistance + convoyDistance);
        const duration = passDuration / split;
        const timing = { duration, iterations, easing: 'linear', fill: 'both' };

        // Keep the current progress so re-measuring doesn't restart the run
        const previous = animations[0];
        const progress = previous ? previous.currentTime / previous.effect.getTiming().duration : 0;

        animations.forEach((animation) => animation.cancel());
        solo.style.animation = 'none';
        convoy.style.animation = 'none';
        animations = [
          solo.animate(
            [
              { transform: 'translateX(-100%)', offset: 0 },
              { transform: `translateX(${stageWidth}px)`, offset: split },
              { transform: `translateX(${stageWidth}px)`, offset: 1 },
            ],
            timing
          ),
          convoy.animate(
            [
              { transform: `translateX(${stageWidth}px)`, offset: 0 },
              { transform: `translateX(${stageWidth}px)`, offset: split },
              { transform: 'translateX(-100%)', offset: 1 },
            ],
            timing
          ),
        ];
        animations.forEach((animation) => (animation.currentTime = progress * duration));
      };

      run();

      // Covers viewport resizes and late-loading icon images in one place
      if ('ResizeObserver' in window) {
        let frame;
        const observer = new ResizeObserver(() => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(run);
        });
        [stage, solo, convoy].forEach((element) => observer.observe(element));
        root.addEventListener('floating-icons:teardown', () => observer.disconnect(), { once: true });
      }
    };

    const init = (scope = document) => {
      scope.querySelectorAll('.floating-icons--gump').forEach(setup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    // Theme editor: drop observers of the old section markup, then set up the new one
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.floating-icons--gump').forEach((root) => {
        root.dispatchEvent(new Event('floating-icons:teardown'));
      });
    });
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  /* Continuous scrolling text: duration scales with content width so the speed feels the same on every screen */
  class AnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this.group = this.querySelector('.announcement-bar__marquee-group');
      if (!this.group) return;

      this.cloneGroups();

      /* The theme editor re-renders only the original block, so rebuild the copies when it changes */
      this.mutationObserver = new MutationObserver(() => {
        this.cloneGroups();
        this.calculateDuration();
      });
      this.mutationObserver.observe(this.group, { childList: true, subtree: true, attributes: true, characterData: true });

      this.resizeObserver = new ResizeObserver(() => this.calculateDuration());
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.mutationObserver?.disconnect();
      this.resizeObserver?.disconnect();
    }

    /* Repeat the text so the strip is always filled while it scrolls */
    cloneGroups() {
      this.querySelectorAll('.announcement-bar__marquee-group[data-clone]').forEach((clone) => clone.remove());

      for (let i = 0; i < 7; i++) {
        const clone = /** @type {HTMLElement} */ (this.group.cloneNode(true));
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => {
          el.removeAttribute('data-shopify-editor-block');
        });
        clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        this.append(clone);
      }
    }

    calculateDuration() {
      const containerWidth = this.clientWidth;
      if (!this.group || !containerWidth) return;

      const speed = parseInt(this.getAttribute('scrolling-speed') || '20', 10);
      const slowFactor = 1 + (Math.min(1600, containerWidth) - 375) / 1225;
      const duration = (speed * slowFactor * this.group.clientWidth) / containerWidth;
      this.style.setProperty('--marquee-duration', `${duration.toFixed(3)}s`);
    }
  }

  if (!customElements.get('announcement-marquee')) {
    customElements.define('announcement-marquee', AnnouncementMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
  /* Basic horizontal image slider: native scroll + snap, with arrows and progress dots */
  class ImageSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.image-slider__track');
      this.dots = this.querySelector('.image-slider__dots-inner');
      this.arrows = this.querySelectorAll('.image-slider__arrow');
      if (!this.track) return;

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => this.scrollBySlide(Number(arrow.dataset.direction)));
      });

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.render());
      this.resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    get step() {
      const slides = this.track.children;
      if (slides.length < 2) return this.track.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    get pageCount() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      return maxScroll > 1 ? Math.ceil(maxScroll / this.step - 0.01) + 1 : 1;
    }

    scrollBySlide(direction) {
      this.track.scrollBy({ left: direction * this.step, behavior: 'smooth' });
    }

    render() {
      if (this.dots) {
        const count = this.pageCount;
        if (this.dots.children.length !== count) {
          this.dots.replaceChildren(...Array.from({ length: count }, () => document.createElement('span')));
        }
        this.dots.hidden = count < 2;
      }
      this.update();
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrollLeft = this.track.scrollLeft;
      const index = Math.round(scrollLeft / this.step);

      if (this.dots) {
        Array.from(this.dots.children).forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      this.arrows.forEach((arrow) => {
        const direction = Number(arrow.dataset.direction);
        arrow.disabled = direction < 0 ? scrollLeft <= 1 : scrollLeft >= maxScroll - 1;
      });
    }
  }

  if (!customElements.get('image-slider')) {
    customElements.define('image-slider', ImageSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
